import useOperationTranslation from "../../hooks/useOperationTranslation";
import { AutoCompleteOption } from "../common/AutoComplete";
import TransferReasonService from "./TransferReasonService";
import { TransferReasonTypes } from "./Types";

const Manipulate = () => {
  const t = useOperationTranslation();

  const getAllReason = (
    props: TransferReasonTypes.Reason
  ): Promise<AutoCompleteOption[]> => {
    return TransferReasonService.get.statusReason(props).then((response) =>
      response.map((element: TransferReasonTypes.ReasonResponse) => ({
        label: `${element.descr} - ${element.code}`,
        value: element.code,
      }))
    );
  };

  // const getLocation = (props: string): Promise<AutoCompleteOption[]> => {
  //   return TransferReasonService.get.location(props).then((response) =>
  //     response.map((element: TransferReasonTypes.Location) => ({
  //       label: element.description,
  //       value: element.code,
  //     }))
  //   );
  // };

  const getLocationsByFilters = (
    props: TransferReasonTypes.LocationsByFiltersRequest
  ): Promise<AutoCompleteOption[]> => {
    return TransferReasonService.get
      .locationsByFilters(props)
      .then((response) =>
        response.content.map(
          (element: TransferReasonTypes.LocationsByFiltersResponse) => ({
            label: `${element.locationEntityDesc} (${addTypeToSentence(
              element.type
            )})`,
            value: `${element.bpCode}-${element.type}`,
          })
        )
      );
  };

  const addTypeToSentence = (type: string) => {
    switch (type) {
      case "PARKING_GO":
        return t("internOptionSelectName.physicalLocationType.parkingGo");
      case "LMS":
        return t("internOptionSelectName.physicalLocationType.lms");
      case "COMPOUND":
        return t("internOptionSelectName.physicalLocationType.compound");
      case "SHOP_REPAIR":
        return t("internOptionSelectName.physicalLocationType.shopRepair");
      default:
        return "";
    }
  };

  const getDrivers = (props: string): Promise<AutoCompleteOption[]> => {
    return TransferReasonService.get.drivers(props).then((response) =>
      response.map((element: TransferReasonTypes.Drivers) => ({
        label: `${element.name} ${element.surname} - ${element.drivingLicenseNumber}`,
        value: element.id,
      }))
    );
  };

  const getPlates = (location: string, locationType: string, tenant: any): Promise<any> => {
    return TransferReasonService.get
      .platesByLocationId(location, locationType, tenant)
      .then((response) =>
        response.map((element: any) => ({
          label: element.plate,
          value: element.plate,
          loadIndex: element.loadIndex,
        }))
      );
  };

  return {
    getAllReason,
    getLocationsByFilters,
    getDrivers,
    getPlates,
  };
};

export default Manipulate;
